import React, { useEffect } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import { Modal } from "@mui/material";
import FieldText from "../../../../order_managment/common/component/form/FieldText";
import FieldDate from "../../../../order_managment/common/component/form/FieldDate";
import "./FilterModalShipmentReport.css";
import useForm from "../../../../order_managment/common/hooks/useForm";
import { filterKey } from "../shipementReportFilterObj";
import moment from "moment";
const style = {
  position: "absolute",
  top: "5rem",
  left: "50%",
  transform: "translate(-50%, 0)",
  width: "50%",
  minWidth: "20rem",
  bgcolor: "background.paper",
  border: "0.1rem solid #017EFA",
  boxShadow: 24,
  borderRadius: "1rem",
  padding: "1rem 0 1rem 2.5rem",
};

const FilterModalShipmentReport = ({
  setSelectModal,
  selectModal,
  onFillterHandler,
  bodyData,
}) => {
  const orderRefNumber = useForm();
  const shipmentNumber = useForm();
  const constainerNumber = useForm();
  const cost = useForm();
  const houseBillNumber = useForm();
  const masterBillNumber = useForm();
  const consignorName = useForm();
  const consigneeName = useForm();
  const vesseelName = useForm();
  const OriginUnloco = useForm();
  const destinationUnloco = useForm();
  const destinationName = useForm();
  const originName = useForm();
  const ETDFromDate = useForm();
  const ETDToDate = useForm();
  const ETAFromDate = useForm();
  const ETAToDate = useForm();
  
  const onClear = () => {
    orderRefNumber.setValue("");
    shipmentNumber.setValue("");
    constainerNumber.setValue("");
    cost.setValue("");
    houseBillNumber.setValue("");
    masterBillNumber.setValue("");
    consignorName.setValue("");
    consigneeName.setValue("");
    vesseelName.setValue("");
    OriginUnloco.setValue("");
    destinationUnloco.setValue("");
    destinationName.setValue("");
    originName.setValue("");
    ETDFromDate.setValue("");
    ETDToDate.setValue("");
    ETAFromDate.setValue("");
    ETAToDate.setValue("");
    onFillterHandler({ ...filterKey });
  };
  const onApplyFilters = () => {
    const body = {
      ShipmentId: shipmentNumber.value,
      OrderRef: orderRefNumber.value,
      HouseBillNumber: houseBillNumber.value,
      MasterBillNumber: masterBillNumber.value,
      VesselName: vesseelName.value,
      ConsignorName: consignorName.value,
      ConsigneeName: consigneeName.value,
      OriginUNLOCO: OriginUnloco.value,
      DestinationUNLOCO: destinationUnloco.value,
      OriginName: originName.value,
      ContainerNumbers: constainerNumber.value,
      Cost: Number(cost?.value ?? 0),
      DestinationName: destinationName.value,
      ShipmentOriginETDFrom: ETDFromDate.value
        ? moment(ETDFromDate.value).format("YYYY-MM-DD HH:mm:ss")
        : "",
      ShipmentOriginETDTo: ETDToDate.value
        ? moment(ETDToDate.value).format("YYYY-MM-DD HH:mm:ss")
        : "",
      ShipmentDestinationETAFrom: ETAFromDate.value
        ? moment(ETAFromDate.value).format("YYYY-MM-DD HH:mm:ss")
        : "",
      ShipmentDestinationETATo: ETAToDate.value
        ? moment(ETAToDate.value).format("YYYY-MM-DD HH:mm:ss")
        : "",
    };
    // await context.setReportData([]);
    onFillterHandler({ ...body });
    setSelectModal({
      filter: false,
      selectCol: false,
    });
  };
  useEffect(() => {
    orderRefNumber.setValue(bodyData?.OrderRef ?? "");
    shipmentNumber.setValue(bodyData?.ShipmentId ?? "");
    constainerNumber.setValue(bodyData?.ContainerNumber ?? "");
    cost.setValue(bodyData?.Cost ?? "");
    houseBillNumber.setValue(bodyData?.HouseBillNumber ?? "");
    masterBillNumber.setValue(bodyData?.MasterBillNumber ?? "");
    consignorName.setValue(bodyData?.ConsignorName ?? "");
    consigneeName.setValue(bodyData?.ConsigneeName ?? "");
    vesseelName.setValue(bodyData?.VesselName ?? "");
    OriginUnloco.setValue(bodyData?.OriginUNLOCO ?? "");
    destinationUnloco.setValue(bodyData?.DestinationUNLOCO ?? "");
    destinationName.setValue(bodyData?.DestinationName ?? "");
    originName.setValue(bodyData?.OriginName ?? "");
    ETDFromDate.setValue(bodyData?.ShipmentOriginETDFrom ?? null);
    ETDToDate.setValue(bodyData?.ShipmentOriginETDTo ?? null);
    ETAFromDate.setValue(bodyData?.ShipmentDestinationETAFrom ?? null);
    ETAToDate.setValue(bodyData?.ShipmentDestinationETATo ?? null);
  }, []);
  return (
    <Modal
      open={selectModal?.filter}
      className={`modalBox`}
      onClose={() =>
        setSelectModal({
          filter: false,
          selectCol: false,
        })
      }
    >
      <Box sx={style}>
        <div className="modalHeader">
          <h5>Select Columns</h5>
          <div
            className="closeIcon"
            onClick={() =>
              setSelectModal({
                filter: false,
                selectCol: false,
              })
            }
          >
            <CloseIcon
              onClick={() =>
                setSelectModal({
                  filter: false,
                  selectCol: false,
                })
              }
            />
          </div>
        </div>
        {/* <div className="_solidButton">
          <button onClick={() => {}}>Apply</button>
        </div> */}
        <div className="_modalBody container-fluid">
          <div className="row ">
            <div className="col-12">
              <Accordion defaultExpanded={true}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography>shipment Details</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="row">
                    <div className="col-md-6 col-12">
                      <FieldText
                        label="OrderRef Number"
                        value={orderRefNumber.value}
                        onChange={orderRefNumber.onChange}
                        error={orderRefNumber.error}
                        errorMsg={orderRefNumber.errorMsg}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <FieldText
                        label="Shipment Number"
                        value={shipmentNumber.value}
                        onChange={shipmentNumber.onChange}
                        error={shipmentNumber.error}
                        errorMsg={shipmentNumber.errorMsg}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <FieldText
                        label="ContainerNumber"
                        value={constainerNumber.value}
                        onChange={constainerNumber.onChange}
                        error={constainerNumber.error}
                        errorMsg={constainerNumber.errorMsg}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <FieldText
                        label="Cost"
                        value={cost.value == 0 ? "" : cost.value}
                        onChange={cost.onChange}
                        error={cost.error}
                        errorMsg={cost.errorMsg}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <FieldText
                        label="HouseBillNumber "
                        value={houseBillNumber.value}
                        onChange={houseBillNumber.onChange}
                        error={houseBillNumber.error}
                        errorMsg={houseBillNumber.errorMsg}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <FieldText
                        label="MasterBillNumber "
                        value={masterBillNumber.value}
                        onChange={masterBillNumber.onChange}
                        error={masterBillNumber.error}
                        errorMsg={masterBillNumber.errorMsg}
                      />
                    </div>
                    {/* <div className="col-md-6 col-12">
                      <FieldDate label="Order Date From" />
                    </div>
                    <div className="col-md-6 col-12">
                      <FieldDate label="Order Date To" />
                    </div> */}
                    <div className="col-md-6 col-12">
                      <FieldText
                        label="ConsignorName"
                        value={consignorName.value}
                        onChange={consignorName.onChange}
                        error={consignorName.error}
                        errorMsg={consignorName.errorMsg}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <FieldText
                        label="ConsigneeName"
                        value={consigneeName.value}
                        onChange={consigneeName.onChange}
                        error={consigneeName.error}
                        errorMsg={consigneeName.errorMsg}
                      />
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
            <div className="col-12">
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography>Route</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="row">
                    <div className="col-md-6 col-12">
                      <FieldDate
                        label="ETD Date From"
                        value={ETDFromDate.value}
                        onChange={ETDFromDate.onDateChange}
                        error={ETDFromDate.error}
                        errorMsg={ETDFromDate.errorMsg}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <FieldDate
                        label="ETD Date To"
                        value={ETDToDate.value}
                        onChange={ETDToDate.onDateChange}
                        error={ETDToDate.error}
                        errorMsg={ETDToDate.errorMsg}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <FieldDate
                        label="ETA Date From"
                        value={ETAFromDate.value}
                        onChange={ETAFromDate.onDateChange}
                        error={ETAFromDate.error}
                        errorMsg={ETAFromDate.errorMsg}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <FieldDate
                        label="ETA Date To"
                        value={ETAToDate.value}
                        onChange={ETAToDate.onDateChange}
                        error={ETAToDate.error}
                        errorMsg={ETAToDate.errorMsg}
                      />
                    </div>
                    {/* <div className="col-md-6 col-12">
                      <FieldDate label="Cut-Off Date From" />
                    </div>
                    <div className="col-md-6 col-12">
                      <FieldDate label="Cut-Off Date To" />
                    </div> */}
                    <div className="col-md-6 col-12">
                      <FieldText
                        label="VesselName"
                        value={vesseelName.value}
                        onChange={vesseelName.onChange}
                        error={vesseelName.error}
                        errorMsg={vesseelName.errorMsg}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <FieldText
                        label="OriginUNLOCO"
                        value={OriginUnloco.value}
                        onChange={OriginUnloco.onChange}
                        error={OriginUnloco.error}
                        errorMsg={OriginUnloco.errorMsg}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <FieldText
                        label="DestinationUNLOCO"
                        value={destinationUnloco.value}
                        onChange={destinationUnloco.onChange}
                        error={destinationUnloco.error}
                        errorMsg={destinationUnloco.errorMsg}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <FieldText
                        label="DestinationName"
                        value={destinationName.value}
                        onChange={destinationName.onChange}
                        error={destinationName.error}
                        errorMsg={destinationName.errorMsg}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <FieldText
                        label="OriginName"
                        value={originName.value}
                        onChange={originName.onChange}
                        error={originName.error}
                        errorMsg={originName.errorMsg}
                      />
                    </div>
                    {/* <div className="col-md-6 col-12">
                      <FieldText label="Origin Port Code" />
                    </div>
                    <div className="col-md-6 col-12">
                      <FieldText label="Destination Port Code" />
                    </div> */}
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
            <div className="col-12">
              <div className="_modalFooter justify-content-between">
                <div className="_outlineButton">
                  <button onClick={onClear}>Clear Filter</button>
                </div>
                <div className="_solidButton">
                  <button onClick={onApplyFilters}>Apply</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default FilterModalShipmentReport;
